import { useTranslation } from 'react-i18next';

import StatusColorsBlock from './StatusColorsBlock';

import MctSvg from 'pages/InteractiveMap/customMarker/MakerSvgS/MctSvg';
import SbsSvg from 'pages/InteractiveMap/customMarker/MakerSvgS/SbsSvg';
import { DevicesColors } from 'pages/InteractiveMap/customMarker/constants';
import { TrapStatus } from 'api/InteractiveMap/types';

const DevicesTab = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h5>{t('MapLegend.DevicesTab.markerExamples')}</h5>
      <div className="d-flex gap-2 align-items-center border-bottom mb-2">
        <MctSvg caughtPests={0} status={TrapStatus.success} number={1} />
        <span className="ml-2 text-dark">{t('MapLegend.DevicesTab.multiCatchTrap')}</span>
      </div>
      <div className="d-flex flex-column gap-2 px-3 mb-4">
        <h5 className="text-center">{t('MapLegend.DevicesTab.statusColors')}</h5>
        <div className="d-flex flex-column gap-2">
          <StatusColorsBlock
            status={DevicesColors.success}
            description={t('MapLegend.DevicesTab.trapActiveNoCaptures')}
          />
          <StatusColorsBlock status={DevicesColors.warning} description={t('MapLegend.DevicesTab.trapActive1Mice')} />
          <StatusColorsBlock status={DevicesColors.danger} description={t('MapLegend.DevicesTab.trapActive2Mice')} />
          <StatusColorsBlock status={DevicesColors.dark} description={t('MapLegend.DevicesTab.trapInactive')} />
        </div>
      </div>
      <div className="d-flex gap-2 align-items-center border-bottom mb-2">
        <SbsSvg caughtPests={2} percentageOfFilling={100} status={TrapStatus.success} number={1} />
        <span className="ml-2 text-dark">{t('MapLegend.DevicesTab.baitStation')}</span>
      </div>
      <div className="d-flex flex-column gap-2 px-3">
        <h5 className="text-center">{t('MapLegend.DevicesTab.statusColors')}</h5>
        <div className="d-flex flex-column gap-2">
          <StatusColorsBlock
            status={DevicesColors.success}
            description={t('MapLegend.DevicesTab.activeNoConsumption')}
          />
          <StatusColorsBlock status={DevicesColors.warning} description={t('MapLegend.DevicesTab.active1099Bait')} />
          <StatusColorsBlock
            status={DevicesColors.danger}
            description={t('MapLegend.DevicesTab.activeLessThan10Bait')}
          />
          <StatusColorsBlock status={DevicesColors.dark} description={t('MapLegend.DevicesTab.stationInactive')} />
        </div>
      </div>
    </div>
  );
};

export default DevicesTab;
